import { Checkbox } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import React from "react";

import { MenuItem } from "@mui/material";

const FormDialogAlterarTipo = (props) => {
  const [identificador, setIdentificador] = React.useState(null);
  const [tipo, setTipo] = React.useState("");
  const [uuid, setUuid] = React.useState("");
  const [viewOnly, setViewOnly] = React.useState(false);

  React.useEffect(() => {
    setIdentificador(props.identificador);
    setTipo(props.identificador ? props.identificador.tipo : "");
    setUuid(props.identificador ? props.identificador.uuid : "");
    setViewOnly(props.identificador ? props.identificador.viewOnly : false);
  }, [props.identificador]);

  const handleClose = () => {
    props.handleClose();
  };

  const handleChangeTipo = (event) => {
    setTipo(event.target.value);
  };

  const handleChangeUUID = (event) => {
    var uuid = event.target.value;
    if (uuid.match(/ /)) {
      uuid = uuid.replace(/ /, "-");
    }
    uuid = uuid.toLowerCase();
    setUuid(uuid);
  };

  const handleSave = () => {
    identificador.tipo = tipo;
    identificador.uuid = uuid;
    identificador.viewOnly = viewOnly;
    props.alterarIdentificador(identificador, () => {
      handleClose();
    });
  };

  return (
    <div>
      <Dialog
        open={identificador !== null}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Editar identificador</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            select
            id="tipo"
            sx={{ marginY: "0.5rem" }}
            value={tipo || ""}
            label="Tipo do identificador"
            fullWidth
            name="tipo"
            variant="outlined"
            onChange={handleChangeTipo}
          >
            <MenuItem key={"COMANDA"} value={"COMANDA"}>
              Comanda
            </MenuItem>
            <MenuItem key={"MESA"} value={"MESA"}>
              Mesa
            </MenuItem>
            <MenuItem key={"SEQUENCIAL"} value={"SEQUENCIAL"}>
              Sequencial
            </MenuItem>
            <MenuItem key={"DELIVERY"} value={"DELIVERY"}>
              Delivery
            </MenuItem>
          </TextField>

          {tipo === "DELIVERY" ? (
            <React.Fragment>
              <TextField
                id="uuid"
                value={uuid || ""}
                label="Link de acesso"
                fullWidth
                name="uuid"
                onChange={handleChangeUUID}
                margin="normal"
                variant="outlined"
                required
              />

              <TextField
                value={
                  `${process.env.REACT_APP_APP_QRPEDIR_URL}checkout/${uuid}` ||
                  ""
                }
                label="Link para compartilhar (copie e compartilhe com seus clientes)"
                fullWidth
                name="link"
                margin="normal"
                variant="outlined"
                InputProps={{
                  readOnly: true,
                }}
              />
            </React.Fragment>
          ) : null}

          <Box display="inline">
            <FormControlLabel
              control={
                <Checkbox
                  checked={viewOnly}
                  onChange={() => setViewOnly(!viewOnly)}
                  name="Somente visualização"
                  color="secondary"
                />
              }
              label="Somente visualização"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleSave} variant="contained" color="primary">
            Salvar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default FormDialogAlterarTipo;
